
import { WorkerProfile, Review, EarningsData, JobRequest, UserProfile, AdBanner, ServiceCategory, PlatformFeeConfig, Gender, UserRole, Report, WithdrawalRequest, Transaction } from './types';

// Default configuration used ONLY for initial state before DB loads
export const DEFAULT_FEE_CONFIG: PlatformFeeConfig = {
    baseCommissionPercent: 10,
    newWorkerFreeJobsCount: 5,
    dynamicMultiplier: 1.0,
    isSystemFreeMode: false,
    landingBackgroundType: 'image',
    landingVideoUrl: '',
    landingImageUrl: 'https://images.unsplash.com/photo-1581578731117-104f2a41272c?q=80&w=1470&auto=format&fit=crop',
    paymentQrUrl: '',
    upiId: '',
    bankDetails: ''
};

export const DEFAULT_SERVICE_CATEGORIES: ServiceCategory[] = [
    { id: 'cat_1', name: 'Plumber', basePrice: 350, isActive: true },
    { id: 'cat_2', name: 'Electrician', basePrice: 400, isActive: true },
    { id: 'cat_3', name: 'Carpenter', basePrice: 450, isActive: true },
    { id: 'cat_4', name: 'Mason', basePrice: 600, isActive: true },
    { id: 'cat_5', name: 'Painter', basePrice: 300, isActive: true },
    { id: 'cat_6', name: 'Cleaner', basePrice: 250, isActive: true },
    { id: 'cat_7', name: 'Mechanic', basePrice: 500, isActive: true },
    { id: 'cat_8', name: 'Gardener', basePrice: 350, isActive: true },
];

export const SKILL_TAGS: Record<string, string[]> = {
    'Plumber': ['Leak Repair', 'Pipe Fitting', 'Bathroom Fittings', 'Clogged Drains', 'Water Tank Cleaning', 'Water Heater Repair'],
    'Electrician': ['House Wiring', 'Fan Repair', 'AC Installation', 'Switchboard Repair', 'Inverter Setup', 'Lighting Decor'],
    'Carpenter': ['Door Repair', 'Furniture Assembly', 'Modular Kitchen', 'Locks & Latches', 'Wood Polishing', 'Window Frame Repair'],
    'Mason': ['Wall Plastering', 'Tile Fitting', 'Brickwork', 'Concrete Repair', 'Bathroom Renovation', 'Floor Leveling'],
    'Painter': ['Interior Painting', 'Wall Texture', 'Exterior Painting', 'Metal Polishing', 'Stenciling', 'Waterproofing'],
    'Cleaner': ['Deep Home Cleaning', 'Kitchen Cleaning', 'Bathroom Sanitizing', 'Sofa/Carpet Cleaning', 'Window Cleaning', 'Disinfection'],
    'Mechanic': ['Two-Wheeler Service', 'Engine Diagnostics', 'Brake Repair', 'Roadside Assistance', 'Oil Change', 'Clutch Work'],
    'Gardener': ['Garden Maintenance', 'Lawn Mowing', 'Plant Potting', 'Fertilizing', 'Hedge Trimming', 'Pest Control (Plants)']
};

export const GENDER_OPTIONS: Gender[] = ['Male', 'Female', 'Other'];

// MOCK DATA (Emptied to avoid confusion with live Supabase data)
export const MOCK_USERS: UserProfile[] = [];
export const MOCK_WORKERS: WorkerProfile[] = [];
export const MOCK_REVIEWS: Review[] = [];
export const MOCK_EARNINGS: EarningsData[] = [];
export const MOCK_JOBS: JobRequest[] = [];
export const MOCK_ADS: AdBanner[] = [];
export const MOCK_REPORTS: Report[] = [];
export const MOCK_WITHDRAWALS: WithdrawalRequest[] = [];
export const MOCK_TRANSACTIONS: Transaction[] = [];

export const MOCK_CMS = [
    { slug: 'privacy', title: 'Privacy Policy', content: '# Privacy Policy\n\nWe value your privacy. Your data is secure with us.' },
    { slug: 'terms', title: 'Terms of Service', content: '# Terms of Service\n\nBy using Hum Hena, you agree to fair usage policies.' },
    { slug: 'help', title: 'Help Center', content: '# Help Center\n\nContact support at support@humhena.com for assistance.' }
];

export const AVAILABLE_SKILLS = ['Plumber', 'Electrician', 'Carpenter', 'Mason', 'Painter', 'Cleaner', 'Mechanic', 'Gardener'];
